import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "stc-notification__content" }
const _hoisted_2 = ["src", "width", "height"]
const _hoisted_3 = { class: "stc-notification__text-container" }
const _hoisted_4 = {
  key: 0,
  class: "stc-notification__title"
}
const _hoisted_5 = { class: "stc-notification__text" }

import { computed } from 'vue';

import type { StcNotificationType } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'stc-notification-content',
  props: {
    description: {},
    title: {},
    type: { default: 'error' },
    iconSize: { default: 24 }
  },
  setup(__props: any) {

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

const NOTIFICATION_ICON_BY_TYPE: Record<StcNotificationType, string> = {
  error: `${ICONS_BASE}/error.svg`,
  success: `${ICONS_BASE}/share-icons/success-circle-icon.svg`,
  warning: `${ICONS_BASE}/triangle_warning_icon.svg`,
  info: `${ICONS_BASE}/information_circle.svg`,
};

const DEFAULT_TITLE_BY_TYPE: Record<StcNotificationType, string> = {
  error: 'Ошибка',
  success: 'Успешно',
  warning: 'Внимание',
  info: 'Информация',
};

const props = __props;

const iconSrc = computed(() => NOTIFICATION_ICON_BY_TYPE[props.type]);
const iconStyle = computed(() => ({
  width: `${props.iconSize}px`,
  height: `${props.iconSize}px`,
}));
const displayTitle = computed(() => props.title ?? DEFAULT_TITLE_BY_TYPE[props.type]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: iconSrc.value,
      alt: "",
      class: "stc-notification__icon",
      width: __props.iconSize,
      height: __props.iconSize,
      style: _normalizeStyle(iconStyle.value)
    }, null, 12, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (displayTitle.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(displayTitle.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.description), 1)
    ])
  ]))
}
}

})